import React from "react";
import { Collapse } from "react-bootstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import CurrentSituation from "../FormComponents/CurrentSituation";
import IdeaBank from "../FormComponents/IdeaBank";
import Evaluation from "../FormComponents/Evaluation";
import Implementation from "../FormComponents/Implementation";
import ActionPlan from "../FormComponents/ActionPlan";

const HistoryDetail = ({
  show,
  handleClose,
  color,
  columnName,
  columnNo,
  history,
  config,
}) => {
  const getTaskForm = () => {
    switch (columnNo) {
      case 0:
        return <CurrentSituation selectedTask={history} config={config} />;
      case 1:
        return <IdeaBank selectedTask={history} config={config} />;
      case 2:
        return <ActionPlan selectedTask={history} config={config} />;
      case 3:
        return <Implementation selectedTask={history} config={config} />;
      case 4:
        return <Evaluation selectedTask={history} config={config} />;
      default:
        return "";
    }
  };

  return (
    <Collapse in={show}>
      <div id="example-collapse-text">{getTaskForm()}</div>
    </Collapse>
  );
};

export default HistoryDetail;
